import type { ReactNode } from 'react';
import FormGroup from '../../generic/FormGroup';
import translations from '../../../translations';
import type { Environment } from '../../../types/environment';
import type { UserTenantResponseAPI } from '../../../types/user';
type Props = {
    selectedEnvironment: string;
    setSelectedTheme: (theme: string) => void;
    themes: string[];
    environments: Environment[];
    onEnvironmentSelect: (selectedOption: React.ChangeEvent<HTMLSelectElement>) => void;
    tenant: UserTenantResponseAPI;
};

const ExportThemeForm = ({
    selectedEnvironment,
    setSelectedTheme,
    themes,
    environments,
    onEnvironmentSelect,
    tenant,
}: Props) => {
    const tenantSettings = tenant?.tenantSettings;
    const isEnvironmentsOn = tenantSettings?.environments;
    const themeSelectionAvailable =
        !isEnvironmentsOn || (isEnvironmentsOn && selectedEnvironment !== '');

    const environmentOptions = [
        <option value="" key="no environment">
            {translations.ENVIRONMENT_filters_select_environment}
        </option>,
    ].concat(
        environments.map((environment) => (
            <option value={environment.id} key={environment.id}>
                {environment.name}
            </option>
        )),
    );

    const themeOptions =
        themes
            ?.filter((theme) => theme !== 'default')
            .map((theme) => (
                <option value={theme} key={theme}>
                    {theme}
                </option>
            )) ?? [];
    themeOptions.unshift(
        <option value="" key="">
            {translations.THEMES_select}
        </option>,
    );

    return (
        <div className="export-theme">
            {isEnvironmentsOn && (
                <FormGroup htmlFor="theme-environment-select">
                    <select
                        onChange={onEnvironmentSelect}
                        className="select-flow form-control"
                        data-testid="themeEnvironmentSelect"
                        id="theme-environment-select"
                    >
                        {environmentOptions as ReactNode}
                    </select>
                </FormGroup>
            )}
            <FormGroup htmlFor="theme-select">
                <select
                    onChange={(selectedOption) =>
                        setSelectedTheme(selectedOption?.target?.value ?? '')
                    }
                    className="select-flow form-control"
                    data-testid="themeSelect"
                    id="theme-select"
                    disabled={!themeSelectionAvailable}
                >
                    {themeOptions as ReactNode}
                </select>
            </FormGroup>
        </div>
    );
};

export default ExportThemeForm;
